<div class="heading py-5">
  <h1 class="bold font-curve-large">Buttons</h1>
  <app-dependency-link></app-dependency-link>
</div>

<app-buttons-demo></app-buttons-demo>
